export function observe(element: HTMLElement, options?: { threshold?: number; rootMargin?: string }) {
  // Users who prefer reduced motion get the final state immediately.
  if (typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    element.classList.add("visible");
    return { destroy() {} };
  }

  const threshold = options?.threshold ?? 0.1;
  const rootMargin = options?.rootMargin ?? "0px 0px -40px 0px";

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          element.classList.add("visible");
          io.unobserve(element);
        }
      });
    },
    { threshold, rootMargin }
  );

  io.observe(element);

  return {
    destroy() {
      io.disconnect();
    }
  };
}
